import { ShortCode } from '@highereducation/wordpress';
import { Flex } from '@highereducation/hen-ui';

interface TextStackShortcodeProps {
  gap?: 'xxs' | 'xs' | 'sm' | 'md';
  align?: 'start' | 'center' | 'end';
  children?: React.ReactNode;
  [key: string]: unknown;
}

/**
 * TextStack - Semantic shortcode for grouping text elements (brow, heading, text)
 * with tight vertical spacing. Keeps related text content visually connected.
 */
export const TextStackShortcode: ShortCode<TextStackShortcodeProps> = {
  component: ({ gap = 'xxs', align = 'start', children }) => {
    return (
      <Flex direction='column' gap={gap} align={align}>
        {children}
      </Flex>
    );
  },
};
